import React from 'react'

export default function Check({ className }) {
  return (
    <svg viewBox="0 0 16 15" className={className}>
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M2.132 6.75l3.697 3.026 7.537-8.85a1.206 1.206 0 011.703-.135c.482.412.558 1.125.195 1.631L7.422 13.29 6.189 15 4.84 13.47.458 8.494A1.216 1.216 0 01.564 6.78a1.21 1.21 0 011.568-.03z"
      />
    </svg>
  )
}
